export type FleetTodoStatus = "pending" | "in_progress" | "completed" | "cancelled";

export type FleetTodoItem = {
  id: string;
  content: string;
  status: FleetTodoStatus;
};

function normalizeFleetTodoStatus(raw: unknown): FleetTodoStatus {
  if (typeof raw !== "string") {
    return "pending";
  }
  const value = raw.trim().toLowerCase();
  if (value === "pending" || value === "todo" || value === "open") {
    return "pending";
  }
  if (value === "in_progress" || value === "in-progress" || value === "running") {
    return "in_progress";
  }
  if (value === "completed" || value === "done" || value === "success") {
    return "completed";
  }
  if (value === "cancelled" || value === "canceled" || value === "failed" || value === "error") {
    return "cancelled";
  }
  return "pending";
}

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === "object" && value !== null;
}

export function parseFleetTodoItems(raw: unknown): FleetTodoItem[] {
  if (!Array.isArray(raw)) {
    return [];
  }
  const out: FleetTodoItem[] = [];
  for (const item of raw) {
    if (!isRecord(item)) {
      continue;
    }
    const id = typeof item.id === "string" ? item.id.trim() : "";
    const content = typeof item.content === "string" ? item.content.trim() : "";
    const status = normalizeFleetTodoStatus(item.status);
    if (id && content) {
      out.push({ id, content, status });
    }
  }
  return out;
}

export function parseFleetTodosUpdated(payload: unknown): {
  sessionKey: string;
  todos: FleetTodoItem[];
} | null {
  if (!isRecord(payload)) {
    return null;
  }
  const sessionKey = typeof payload.sessionKey === "string" ? payload.sessionKey.trim() : "";
  const todos = parseFleetTodoItems(payload.todos);
  if (!sessionKey) {
    return null;
  }
  return { sessionKey, todos };
}
